export const DEFAULT_IMAGE =
  'https://images.development.autone.io/product-images/default.jpeg';
